function parseJSON(response) {
  return new Promise((resolve, reject) => {
    if (!response.ok) {
      response
        .json()
        .then((errorData) => reject(errorData))
        .catch((_error) => reject(new Error(response.statusText))); // Parse JSON error response
      return;
    }

    // Check if Content-Length is 0 or status is 204
    const contentLength = response.headers.get("Content-Length");
    if (
      response.status === 204 ||
      (contentLength !== null && Number(contentLength) === 0)
    ) {
      resolve({
        status: response.status,
        ok: response.ok,
        json: null,
      }); // No content
      return;
    }
    response.json().then((json) => {
      resolve({
        status: response.status,
        ok: response.ok,
        json: json,
      });
    });
  });
}

export default function request(url, options) {
  return new Promise((resolve, reject) => {
    fetch(url, options)
      .then(parseJSON)
      .then((response) => {
        if (response.ok) {
          return resolve(response.json);
        }
        return reject(response.json);
      })

      .catch((error) => {
        reject({ message: error.message });
      });
  });
}

export function get(url) {
  return request(url, {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
  });
}

export function post(url, payload) {
  const options = {
    method: "POST",
    body: JSON.stringify(payload),
    headers: new Headers({
      "Content-Type": "application/json",
    }),
  };
  return request(url, options);
}
